import * as React from 'react'

interface IProps {
    children?: React.ReactNode;
};

interface IPage {
    formId: number,
    page: number
};

interface ISetWebTokenAction { type: "setWebToken", payload: string };
interface IClearWebTokenAction { type: "clearWebToken", payload: undefined };
interface ISetPage { type: "setPage", payload: IPage };
interface ISetDialogAnswerHelp { type: "setDialogAnswerHelp", payload: boolean[] };
interface ISetReqolAnswers { type: "setReqolAnswers", payload: number[] };

interface ISessionState {
    dialogAnswerHelp: boolean[],
    loginParams: string,
    page: IPage | undefined,
    webToken: string,
    reqolAnswers: number[]
};

type Actions = ISetWebTokenAction | IClearWebTokenAction | ISetPage | ISetReqolAnswers | ISetDialogAnswerHelp;

const initialState: ISessionState = {
    dialogAnswerHelp: [false, false, false, false, false, false, false, false, false, false, false],
    loginParams: "",
    page: undefined,
    reqolAnswers: [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1],
    webToken: ""
};

const reducer = (state: typeof initialState, action: Actions) => {
    switch (action.type) {
        case "setWebToken":
            return { ...state, webToken: action.payload };
        case "clearWebToken":
            return { ...state, webToken: "" };
        case "setPage":
            return { ...state, page: action.payload }
        case "setDialogAnswerHelp":
            return { ...state, dialogAnswerHelp: action.payload }
        case "setReqolAnswers":
            return { ...state, reqolAnswers: action.payload }
    }
};

const SessionContext = React.createContext(initialState as unknown as { state: ISessionState, dispatch: React.Dispatch<Actions> });

const SessionContextProvider = (props: IProps) => {
    const [state, dispatch] = React.useReducer(reducer, (initialState as never));
    const formViewerState = (state as ISessionState);
    return <SessionContext.Provider value={{ state: formViewerState, dispatch } as any}>
        {props.children}
    </SessionContext.Provider>
};

export { SessionContext, SessionContextProvider };



// WEBPACK FOOTER //
// ./src/Views/SessionContext.tsx